/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const system = 'System';
export const reminderSetupTitle = 'Reminder Setup';
export const defaultTaskTypeValue = 'CHECKDATE';
export const defaultPlanTypeValue = 'FD';
export const radioGroupPaymentGenerate = 'Payment Status';
export const taskTypeList = [
  {
    name: 'Check Log',
    value: 'CHECKDATE',
  },
  {
    name: 'Collection Letters',
    value: 'COLLECT',
  },
  {
    name: 'Mailed Date',
    value: 'MAILDATE',
  },
  {
    name: 'Elect R/P Suspend',
    value: 'electRPSuspend',
  },
  {
    name: 'Elect R/P Check',
    value: 'electRPCheck',
  },
  {
    name: 'Elect R/P File to be Sent',
    value: 'electRPFiletobeSent',
  },
  {
    name: 'Suspended Check',
    value: 'SUSPNDDATE',
  },
];
export const PLAN_TYPE_DATA = [
  { name: 'Medicaid', value: 'FD' },
  { name: 'Commercial', value: 'COMM' },
  { name: 'State', value: 'ST' },
  { name: 'Supplemental', value: 'SUPP' },
];
export const setPaymentListOptions = [
  { name: 'No Payment Received', value: '1' },
  { name: 'No Payment Received and Amount Owed >0', value: '2' },
  { name: 'Not Paid in Full', value: '3' },
  { name: 'Percent Paid <', value: '4' },
  { name: 'Amount Owed >', value: '5' },
];
